/**
 * Card metadata from `getItem.card` (not runtime series/content — see `get-card-data.ts`).
 * Shared by Jepto report editor and Analytics `fetchCardConfig`.
 *
 * Callers must pass **`pageId`** when scoping a card to a page (report editor, analytics page load).
 * **`paletteId`:** normalize via {@link applyPaletteWireFromApi} after the response.
 *
 * Older AppSync schemas omit `requestId` / `requester` on `getItem.card` — use
 * {@link fetchGetCardItem} which retries with {@link queryGetCardWithoutRequestTracing}.
 */
const GET_CARD_ITEM_SELECTION = `
				cardId
				title
				subtitle
				cardType
				chartType
				controlType
				paletteId
				filterGroup {
					groupId
					targetCardIds
				}
				sources {
					dataSource
				}
				data {
					metrics {
						name
						id
						label
						dataType
						aggregation
					}
					dimensions {
						name
						id
						label
						dataType
					}
					timeDimension {
						dimension
						granularity
						timeDimensionSource
						dateRange
					}
					filters {
						member
						operator
						values
						dataType
					}
					comparison {
						enabled
						period 
					}
					order
				}
				presentation
				visualization
				style {
					card {
						padding
						contentAlignment
					}
					colors {
						light {
							card {
								background
								border
								shadow
							}
						}
						dark {
							card {
								background
								border
								shadow
							}
						}
					}
				}
				icon
				image
				dateCreated
				dateUpdated
				createdBy
				revisions
				pageId
				requestId
				filters {
					filterId
					label
					isGlobal
					filter
				}`;

export const queryGetCardWithoutRequestTracing = `
	query getCard(
		$viewId: ID
		$cardId: ID!
		$pageId: ID
		$accountId: ID
	) {
		getItem {
			card(
				viewId: $viewId
				cardId: $cardId
				pageId: $pageId
				accountId: $accountId
			) {
${GET_CARD_ITEM_SELECTION}
			}
		}
	}
`;

export const queryGetCard = `
	query getCard(
		$viewId: ID
		$cardId: ID!
		$pageId: ID
		$accountId: ID
		$requestId: ID!
		$requester: ID!
	) {
		getItem {
			card(
				viewId: $viewId
				cardId: $cardId
				pageId: $pageId
				accountId: $accountId
				requestId: $requestId
				requester: $requester
			) {
${GET_CARD_ITEM_SELECTION}
			}
		}
	}
`;
